<template>
  <div class="container_IndustrySolutions_phone">
    <div class="header">
      <div class="mash">
        <NavBar_phone></NavBar_phone>
        <div class="title">{{ $t("message.ShanghaiEsunSoftwareFirm") }}</div>
      </div>
    </div>
    <Card_phone>
      <template v-slot:title>公司介绍</template>
      <template v-slot:banner
        ><img src="@/assets/img/gongsijieshao_phone.png"
      /></template>
      <template v-slot:body>
        <div class="CompanyProfile">
          <div class="head">上海奕盛软件有限公司</div>
          <div class="label">卓越创新</div>
          <div class="txt">
            自2000年创建以来,以坚韧的努力和追求卓越的精神不断创新，致力于为中国地区的制造商提供完整的企业管理及IT解决方案帮助打造高效企业迎接全球化发展带来的挑战，并以优良的技术和完美的服务，赢得众多外资与本地客户的信赖。我们高度关注汽车、生命科学、电子、食品饮料和消费品等垂直行业的发展并基于信息简单、自动化等原则协助该行业领域内的制造商
          </div>
          <div class="label">高效管理</div>
          <div class="txt">
            作为全球化之下的制造商追求的目标，是先进制造商标志之一，我们基于企业数据平台帮助制造商达成以下高效运营目标：
          </div>
          <ul>
            <li
              v-for="(item, index) in CompanyProfile"
              :key="index"
              class="list"
            >
              <img src="@/assets/img/juxin19.png" />
              <div>{{ item }}</div>
            </li>
          </ul>
        </div>
      </template>
    </Card_phone>
    <Card_phone>
      <template v-slot:title>关于我们</template>
      <template v-slot:body>
        <div class="AboutUs">
          <div style="display: flex; justify-content: center;">
            <img src="@/assets/img/ESUN_SITE.png" style="width: 80%; margin: 3rem 0" @click="toBaiduEsunSite()">
          </div>
          <!-- <div id="container" style="width: 100%; height: 8rem"></div> -->
          <div class="bottom">
            <div class="label">公司地点</div>
            <div class="txt">
              上海市闵行区浦江镇联航路1588号国家现代服务业软件产业基地SOHO研发楼第8幢
            </div>
            <div class="label">联系我们</div>
            <div class="txt">021-53015840</div>
            <div class="txt">sales@esun.sh.cn</div>
            <div class="txt">support@esun.sh.cn</div>
          </div>
        </div>
      </template>
    </Card_phone>
    <Footer_phone></Footer_phone>
  </div>
</template>
      <script>
import NavBar_phone from "@/components/NavBar_phone.vue";
import Footer_phone from "@/components/Footer_phone.vue";
import Card_phone from "@/components/Card_phone.vue";

export default {
  components: {
    NavBar_phone,
    Footer_phone,
    Card_phone,
  },
  data() {
    return {
      CompanyProfile: [
        "协同、合规与自动化供应链管理",
        "质量＝生命",
        "面向效率与合规的财务管理",
        "自动化业务流程管理",
      ],
    };
  },
  methods: {
    toBaiduEsunSite(){
        window.open("https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%A5%95%E7%9B%9B%E8%BD%AF%E4%BB%B6%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@13527877,3621420,18z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E5%A5%95%E7%9B%9B%E8%BD%AF%E4%BB%B6%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&c=289&src=0&wd2=%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%97%B5%E8%A1%8C%E5%8C%BA&pn=0&sug=1&l=13&b=(13506375,3612771;13555527,3636131)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&sug_forward=735551faf714a5d8c5effbaa&device_ratio=2"); // 新标签页打开目标URL
    },
    mapInit() {
    
    },
  },
  mounted() {
    // this.mapInit();
  },
};
</script>
      <style lang="scss" scoped>
.container_IndustrySolutions_phone {
  display: flex;
  flex-direction: column;
  align-items: center;

  .header {
    height: 10rem;
    width: 100%;
    background-image: url("@/assets/img/you-x-ventures-X8H8vPcelPk-unsplash (2).png");
    background-size: auto 100%;
    // background-position: center;
    background-repeat: no-repeat;
    .mash {
      width: 100%;
      background-color: rgba(35, 37, 133, 0.8);
      // opacity: 0.8;
      height: 100%;
      position: relative;
      .title {
        color: white;
        font-family: DingTalk JinBuTi;
        font-size: 1.5rem;
        text-align: center;
        margin-top: 2rem;
      }
    }
  }
}
</style>